import React, { useState } from 'react';
import { GUI_LANGUAGE_CHANGE_EVENT } from '../events/Gui';

import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import { rest, t, setLocale, getLocale, getAvailableLocales } from '../services';
import { loadingIcon } from '../loadingIcon';

import styles from './LanguageSelector.module.styl';

export function LanguageSelector(props) {
  const [locale, setLocaleState] = useState(undefined);
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);
  const locales = getAvailableLocales();

  if (!locale) {
    const initial = getLocale() || props.defaultLanguage;
    setLocaleState(initial);
    return loadingIcon;
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChange = (nextLocale) => {
  setLocale(nextLocale);

  const resolvedLocale = getLocale();

  setLocaleState(resolvedLocale);
  setAnchorEl(null);
  GUI_LANGUAGE_CHANGE_EVENT.publish(resolvedLocale);
	console.log("Should persist locale here");
  };
  const flagSrc = (loc) => `/assets/img/flags/${loc}.svg`;

  const labelFromLocale = (loc) => t(loc);

  return (
    <>
      <Button
        onClick={handleClick}
        className={styles.button}
      >
        <img
          src={flagSrc(locale)}
          className={styles.flag}
          alt={locale}
        />
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        elevation={0}
        MenuListProps={{
          className: styles.menuList,
        }}
        PaperProps={{
          className: styles.menuPaper,
        }}
      >
        {locales.map((loc) => (
          <MenuItem
            key={loc}
            onClick={() => handleChange(loc)}
            className={styles.menuItem}
          >
            <img
              src={flagSrc(loc)}
              className={styles.menuFlag}
              alt={loc}
            />
            {labelFromLocale(loc)}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}